const fileStatusTypes = [
  'Uploaded',
  'Verification',
  'Preliminary',
  'Final'
]

const DEFAULT_SCHOOL_FILE_LIST = [
  {
    'userFileName': '-----------',
    'fileType': '-----------',
    'fileStatus': '-----------',
    'dateUploaded': '-----------',
    'uploadedBy': '-----------',
  }
];

export function organizeFileStatuses(schoolStatuses) {
  const fileStatuses = {
    Uploaded: [],
    Verification: [],
    Preliminary: [],
    Final: []
  }

  if (schoolStatuses) {
    schoolStatuses.forEach((school) => {
      const filesUploaded = [];
      const filesVerification = [];
      const filesPreliminary = [];
      const filesFinal = [];
      let schoolHasFiles = false;

      const schoolTitle = `${school.school.atpCode} - ${school.school.name}`;

      school.fileStatuses.forEach((fileStatus) => {
        switch (fileStatus.fileStatus) {
          case 'Uploaded':
          case 'Queued':
          case 'Error':
          case 'Processing':
            filesUploaded.push(fileStatus);
            schoolHasFiles = true;
            break;
          case 'Verification':
            filesVerification.push(fileStatus);
            schoolHasFiles = true;
            break;
          case 'Complete':
            filesPreliminary.push(fileStatus);
            schoolHasFiles = true;
            break;
          case 'Final':
            filesFinal.push(fileStatus);
            schoolHasFiles = true;
            break;
          default:
            break;
        }
      });

      if (!schoolHasFiles || (schoolHasFiles && filesUploaded.length > 0)) {
        fileStatuses['Uploaded'].push({
          school: schoolTitle,
          atpCode: school.school.atpCode,
          files: filesUploaded
        });
      }


      if (schoolHasFiles) {
        if (filesUploaded.length > 0) {
        }

        if (filesVerification.length > 0) {
          fileStatuses['Verification'].push({
            school: schoolTitle,
            atpCode: school.school.atpCode,
            files: filesVerification
          });
        }

        if (filesPreliminary.length > 0) {
          fileStatuses['Preliminary'].push({
            school: schoolTitle,
            atpCode: school.school.atpCode,
            files: filesPreliminary
          });
        }

        if (filesFinal.length > 0) {
          fileStatuses['Final'].push({
            school: schoolTitle,
            atpCode: school.school.atpCode,
            files: filesFinal
          })
        }
      }

    });

  }

  return fileStatuses;
}

export function hasFiles(fileStatuses) {
  let filesFound = false;


  fileStatuses.forEach((school) => {
   if (school.files.length > 0) {
      filesFound = true;
    }
  });

  return filesFound;
}

export function schoolHasFiles(schoolFiles) {
  return schoolFiles.length > 0 && schoolFiles[0].fileName;
}

export function checkForSchoolFiles(schoolFiles) {
  return schoolHasFiles(schoolFiles) ? schoolFiles : DEFAULT_SCHOOL_FILE_LIST;
}

export function getSchoolCount(fileStatuses) {
  return (hasFiles(fileStatuses)) ? fileStatuses.length : 0;
}

export function getFirstSchoolFiles(fileLists) {
  if (fileLists['Uploaded'].length > 0) {
    return (schoolHasFiles(fileLists['Uploaded'][0].files)) ? fileLists['Uploaded'][0].files : DEFAULT_SCHOOL_FILE_LIST;
  }

  if (hasFiles(fileLists['Verification'])) {
    return fileLists['Verification'][0].files;
  }

  if (hasFiles(fileLists['Preliminary'])) {
    return fileLists['Preliminary'][0].files;
  }

  if (hasFiles(fileLists['Final'])) {
    return fileLists['Final'][0].files;
  }

  return DEFAULT_SCHOOL_FILE_LIST;
}

export function createSchoolsCanUploadList(schoolList) {
  const schoolsCanUploadList = [];

  schoolList.forEach((school) => {
    schoolsCanUploadList.push(school);
  });

  return schoolsCanUploadList;
}


export function oldOrganizeFileStatuses(schoolStatuses) {
  const fileStatuses = {
    'Uploaded': [],
    'Verification': [],
    'Preliminary': [],
    'Final': []
  };

  schoolStatuses.forEach((schoolStatus) => {
    const schoolFileStatuses = {
      'Uploaded': [],
      'Verification': [],
      'Preliminary': [],
      'Final': []
    }

    schoolStatus.fileStatuses.forEach((schoolFileStatus) => {
      schoolFileStatuses[schoolFileStatus.fileStatus].push(schoolFileStatus);
    })

    fileStatusTypes.forEach((fileStatus, index) => {
      if (schoolFileStatuses[fileStatus].length > 0) {
        const schoolLabel = `${schoolStatus.school.atpCode} - ${schoolStatus.school.name}`;
        fileStatuses[fileStatus][schoolLabel] = schoolFileStatuses[fileStatus]
      }
    })
   });

  return fileStatuses;
}